import { lazy, Suspense, useRef } from 'react';
import { Drawer, FAIcon, SkeletonLoader, Theme, useTranslation } from '@nextgen-web-framework/all';
import { useOutsideClickListener } from '@commerce-webcomponents/ui';

import styles from './CheckoutLocationContainer.module.scss';

const CheckoutLocationHeader = lazy(
  () => import('../../checkout-shipping-details/checkout-location-header/CheckoutLocationHeader'),
);

type LocationProps = {
  setLocation?: (value: boolean) => void;
  onDeliveryAddressConfirm: () => void;
  isMobile?: boolean;
};

const CheckoutLocationContainer = ({ setLocation, onDeliveryAddressConfirm, isMobile = false }: LocationProps) => {
  const locationDrawerRef = useRef(null);
  const t = useTranslation();

  const detectOutsideClick = () => {
    setLocation?.(false);
  };
  useOutsideClickListener(locationDrawerRef, detectOutsideClick);

  const content = (
    <Suspense fallback={<SkeletonLoader height={'130'} />}>
      <CheckoutLocationHeader onConfirmClick={onDeliveryAddressConfirm} isMobile={isMobile} />
    </Suspense>
  );

  if (isMobile) {
    return (
      <Drawer
        data-testid="mobile-location-drawer-testid"
        closeIcon={true}
        closeOnBackdropClick={true}
        bottomGap={0}
        useReactPortal={true}
        portalContainerId={'react-portal-drawer'}
        onClose={() => setLocation?.(false)}
        header={<div>{t('checkout.CheckoutShippingDetailsContainer.headingText')}</div>}
      >
        {content}
      </Drawer>
    );
  }
  return (
    <div ref={locationDrawerRef} className={styles['location-selector-popup']} data-testid="checkout-location-test-id">
      <FAIcon
        className={styles['close-icon-top-bar']}
        data-testid="close-icon-testid"
        iconName={'close'}
        theme={Theme.BLACK}
        onClick={() => setLocation?.(false)}
      />
      {content}
    </div>
  );
};

export default CheckoutLocationContainer;
